export default {"src":"/_next/static/media/carHalfCircleBlue_40.0a727437.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};